import * as ko from "knockout";
import * as moment from "moment";
import * as _ from "lodash";
import { LookupStorage } from "portalframework";
import { CustomObservables } from "CustomObservables";

import {
  address_book_record,
  personExtended,
  person_place,
  person_role,
  place,
  productExtended,
  team_member,
} from "organized";
import labels from "app/labels";

export class access_right {
  openNewWindow: KnockoutObservable<boolean>;
  description: KnockoutObservable<string>;
  function_id: KnockoutObservable<string>;
  parent_function_id: KnockoutObservable<string>;
  read_only: KnockoutObservable<boolean>;
  sequence: KnockoutObservable<number>;
  sales_company: KnockoutObservable<string>;
  show_on_homepage: KnockoutObservable<boolean>;
  show_on_navi: KnockoutObservable<boolean>;
  subfunction_id: KnockoutObservable<string>;
  url: KnockoutObservable<string>;
  sub_access_rights: KnockoutObservableArray<access_right>;
  isActive: KnockoutComputed<boolean>;
  collapse: KnockoutObservable<string>;

  constructor(item: any) {
    this.description = ko.observable(item.description).extend({ maxLength: 50 });
    this.function_id = ko.observable(item.function_id).extend({ maxLength: 50 });
    this.parent_function_id = ko.observable(item.parent_function_id).extend({ maxLength: 50 });
    this.read_only = ko.observable(item.read_only);
    this.sequence = ko.observable(item.sequence);
    this.sales_company = ko.observable(item.sales_company).extend({ maxLength: 50 });
    this.show_on_homepage = ko.observable(item.show_on_homepage);
    this.show_on_navi = ko.observable(item.show_on_navi);
    this.subfunction_id = ko.observable(item.subfunction_id).extend({ maxLength: 50 });
    this.url = ko.observable(item.url).extend({ maxLength: 450 });
    let siteURL: string;
    if (!item.url) {
      siteURL = "/" + item.function_id.toLowerCase();
      if (item.subfunction_id) {
        siteURL += "/" + item.subfunction_id.toLowerCase();
      }
      this.url(siteURL);
    }
    this.sub_access_rights = ko.observableArray();
    this.openNewWindow = ko.observable(item.url);
    if (item.sub_access_rights) {
      this.sub_access_rights(
        _.map(item.sub_access_rights, (ar) => {
          return new access_right(ar);
        }),
      );
    }
    let collapse = (this.collapse = ko.observable(window.innerWidth < 992 ? "collapse" : ""));
    window.addEventListener("resize", function () {
      collapse(window.innerWidth < 992 ? "collapse" : "");
    });
  }
}

export class c_portal_func_access_view {
  c_portal_subf_access_view: KnockoutObservableArray<c_portal_subf_access_view>;
  disabled: KnockoutObservable<string>;
  function_id: KnockoutObservable<string>;
  message_id: KnockoutObservable<string>;
  message_id_descr: KnockoutObservable<string>;
  read_only: KnockoutObservable<string>;
  sequence: KnockoutObservable<number>;
  show_on_navi: KnockoutObservable<string>;
  show_on_homepage: KnockoutObservable<string>;

  constructor(item: any) {
    this.disabled = ko.observable(item.disabled);
    this.function_id = ko.observable(item.function_id);
    this.message_id = ko.observable(item.message_id);
    this.message_id_descr = ko.observable(item.message_id_descr);
    this.read_only = ko.observable(item.read_only);
    this.sequence = ko.observable(item.sequence);
    this.show_on_navi = ko.observable(item.show_on_navi);
    this.show_on_homepage = ko.observable(item.show_on_homepage);
    this.c_portal_subf_access_view = <KnockoutObservableArray<c_portal_subf_access_view>>(
      loadRelation(item, "c_portal_subf_access_view", "array")
    );
  }
}

export class c_portal_subf_access_view {
  disabled: KnockoutObservable<string>;
  parent_function_id: KnockoutObservable<string>;
  subfunction_id: KnockoutObservable<string>;
  message_id: KnockoutObservable<string>;
  message_id_descr: KnockoutObservable<string>;
  read_only: KnockoutObservable<string>;
  sequence: KnockoutObservable<number>;
  show_on_navi: KnockoutObservable<string>;
  show_on_homepage: KnockoutObservable<string>;
  url: KnockoutObservable<string>;

  constructor(item: any) {
    this.disabled = ko.observable(item.disabled);
    this.parent_function_id = ko.observable(item.parent_function_id);
    this.subfunction_id = ko.observable(item.subfunction_id);
    this.message_id = ko.observable(item.message_id);
    this.message_id_descr = ko.observable(item.message_id_descr);
    this.read_only = ko.observable(item.read_only);
    this.sequence = ko.observable(item.sequence);
    this.show_on_navi = ko.observable(item.show_on_navi);
    this.show_on_homepage = ko.observable(item.show_on_homepage);
    this.url = ko.observable(item.url);
  }
}

export class c_wty_claim_defective_part {
  phenomenon_code_description: KnockoutComputed<string>;
  sequence: KnockoutObservable<any>;
  request_unit_id: KnockoutObservable<any>;
  initial_req_type: KnockoutObservable<any>;
  repl_part_serial_id_check: KnockoutObservable<any>;
  part_serial_id_check: KnockoutObservable<any>;
  overall_check: KnockoutObservable<any>;
  part_serial_id: KnockoutObservable<any>;
  part_id: KnockoutObservable<any>;
  phenomenon_code: KnockoutObservable<any>;
  user_def1: KnockoutObservable<any>;
  repl_part_serial_id: KnockoutObservable<any>;
  repl_part_id: KnockoutObservable<any>;
  good_will_transaction: KnockoutObservable<any>;
  good_will_transaction_reason: KnockoutObservable<any>;
  kdxx_unit_claim_status: KnockoutObservable<any>;
  kdxx_unit_reason: KnockoutObservable<any>;
  place_id: KnockoutObservable<any>;
  request_id: KnockoutObservable<any>;
  device_serial_id: KnockoutObservable<any>;
  structure_parent_id: KnockoutObservable<any>;
  device_model_id: KnockoutObservable<any>;
  sold_by: KnockoutObservable<any>;
  llu_status: KnockoutObservable<any>;
  part_type: KnockoutObservable<any>;
  months_coverage: KnockoutObservable<any>;
  effective_dt: KnockoutObservable<any>;
  wty_end_dt: KnockoutObservable<any>;
  wty_cov_type: KnockoutObservable<any>;
  product_id: KnockoutObservable<any>;
  product_structure_id: KnockoutObservable<any>;
  part_of_prod_stuct: KnockoutObservable<any>;
  prod_struct_device_id: KnockoutObservable<any>;
  structure_target_id: KnockoutObservable<any>;
  structure_target_part_id: KnockoutObservable<any>;
  spare_part: KnockoutObservable<any>;
  spare_part_sold_to: KnockoutObservable<any>;
  mk_status: KnockoutObservable<any>;
  mk_check: KnockoutObservable<any>;
  part_status: KnockoutObservable<any>;
  update_structure: KnockoutObservable<any>;
  repl_product_id: KnockoutObservable<any>;
  repl_mk_status: KnockoutObservable<any>;
  repl_spare_part: KnockoutObservable<any>;
  repl_part_status: KnockoutObservable<any>;
  spare_part_invoice_price: KnockoutObservable<any>;
  repl_prod_structure_device_sn: KnockoutObservable<any>;
  repl_update_structure: KnockoutObservable<any>;
  spare_part_invoice_id: KnockoutObservable<any>;

  constructor(item: any) {
    this.sequence = ko.observable(item.sequence);
    this.request_unit_id = ko.observable(item.request_unit_id);
    this.initial_req_type = ko.observable(item.initial_req_type);
    this.repl_part_serial_id_check = ko.observable(item.repl_part_serial_id_check);
    this.part_serial_id_check = ko.observable(item.part_serial_id_check);
    this.overall_check = ko.observable(item.overall_check);
    this.part_serial_id = ko.observable(item.part_serial_id);
    this.part_id = ko.observable(item.part_id);
    this.phenomenon_code = ko.observable(item.phenomenon_code);
    this.user_def1 = ko.observable(item.user_def1);
    this.repl_part_serial_id = ko.observable(item.repl_part_serial_id);
    this.repl_part_id = ko.observable(item.repl_part_id);
    this.good_will_transaction = ko.observable(item.good_will_transaction);
    this.good_will_transaction_reason = ko.observable(item.good_will_transaction_reason);
    this.kdxx_unit_claim_status = ko.observable(item.kdxx_unit_claim_status);
    this.kdxx_unit_reason = ko.observable(item.kdxx_unit_reason);
    this.place_id = ko.observable(item.place_id);
    this.request_id = ko.observable(item.request_id);
    this.device_serial_id = ko.observable(item.device_serial_id);
    this.structure_parent_id = ko.observable(item.structure_parent_id);
    this.device_model_id = ko.observable(item.device_model_id);
    this.sold_by = ko.observable(item.sold_by);
    this.llu_status = ko.observable(item.llu_status);
    this.part_type = ko.observable(item.part_type);
    this.months_coverage = ko.observable(item.months_coverage);
    this.effective_dt = ko.observable(item.effective_dt);
    this.wty_end_dt = ko.observable(item.wty_end_dt);
    this.wty_cov_type = ko.observable(item.wty_cov_type);
    this.product_id = ko.observable(item.product_id);
    this.product_structure_id = ko.observable(item.product_structure_id);
    this.part_of_prod_stuct = ko.observable(item.part_of_prod_stuct);
    this.prod_struct_device_id = ko.observable(item.prod_struct_device_id);
    this.structure_target_id = ko.observable(item.structure_target_id);
    this.structure_target_part_id = ko.observable(item.structure_target_part_id);
    this.spare_part = ko.observable(item.spare_part);
    this.spare_part_sold_to = ko.observable(item.spare_part_sold_to);
    this.mk_status = ko.observable(item.mk_status);
    this.mk_check = ko.observable(item.mk_check);
    this.part_status = ko.observable(item.part_status);
    this.update_structure = ko.observable(item.update_structure);
    this.repl_product_id = ko.observable(item.repl_product_id);
    this.repl_mk_status = ko.observable(item.repl_mk_status);
    this.repl_spare_part = ko.observable(item.repl_spare_part);
    this.repl_part_status = ko.observable(item.repl_part_status);
    this.spare_part_invoice_price = ko.observable(item.spare_part_invoice_price);
    this.repl_prod_structure_device_sn = ko.observable(item.repl_prod_structure_device_sn);
    this.repl_update_structure = ko.observable(item.repl_update_structure);
    this.spare_part_invoice_id = ko.observable(item.spare_part_invoice_id);

    this.phenomenon_code_description = ko.pureComputed(() => {
      return LookupStorage.lookupStorage.getLookupItemDescription("C_PHENOMENOM_CODE", this.phenomenon_code());
    });
  }
}

export class SearchResult {
  count: number;
  data: any;
  lookups?: any;

  constructor(item) {
    this.data = item.data;
    this.lookups = item.lookups;
    this.count = item.count;
  }
}

//aa

export class Readings {
  meter_reading_id: KnockoutObservable<string>;
  meter_value: KnockoutObservable<string>;
  old_meter_value: KnockoutObservable<string>;
  meter_name: KnockoutObservable<string>;
  read_type: KnockoutObservable<string>;
  product_id: KnockoutObservable<string>;
  reading_dt: KnockoutObservable<Date>;
  reading_dttm: KnockoutObservable<any>;
  task_id: KnockoutObservable<string>;

  constructor(item) {
    this.meter_reading_id = ko.observable(item.meter_reading_id);
    this.old_meter_value = ko.observable(item.meter_value);
    this.meter_value = ko.observable(item.meter_value);
    this.meter_name = ko.observable(item.meter_name);
    this.read_type = ko.observable(item.read_type);
    this.product_id = ko.observable(item.product_id);
    this.reading_dttm = ko.observable(item.reading_dttm);
    this.task_id = ko.observable(item.task_id);
    if (item.reading_dttm && item.reading_dttm !== "") {
      this.reading_dt = ko.observable(formatJSONDate(item.reading_dttm));
      this.reading_dttm = CustomObservables.formattedDateTimeObservable(this.reading_dt);
    }
  }
}

export class TechReadings {
  meter_reading_id: KnockoutObservable<string>;
  meter_value: KnockoutObservable<string>;
  old_meter_value: KnockoutObservable<string>;
  meter_name: KnockoutObservable<string>;
  read_type: KnockoutObservable<string>;
  product_id: KnockoutObservable<string>;
  reading_dt: KnockoutObservable<Date>;
  reading_dttm: KnockoutObservable<any>;
  task_id: KnockoutObservable<string>;
  meter_reading_seq: KnockoutObservable<string>;

  constructor(item) {
    this.meter_reading_id = ko.observable(item.meter_reading_id);
    this.old_meter_value = ko.observable(item.meter_value);
    this.meter_value = ko.observable(item.meter_value);
    this.meter_name = ko.observable(item.meter_name);
    this.read_type = ko.observable(item.pending == "Y" ? "PENDING" : item.read_type);
    this.product_id = ko.observable(item.product_id);
    this.reading_dttm = ko.observable(item.reading_dttm);
    this.task_id = ko.observable(item.task_id);
    this.meter_reading_seq = ko.observable(item.meter_reading_seq);
    if (item.reading_dttm && item.reading_dttm !== "") {
      this.reading_dt = ko.observable(formatJSONDate(item.reading_dttm));
      this.reading_dttm = CustomObservables.formattedDateTimeObservable(this.reading_dt);
    }
  }
}

export class place_address {
  address_id: KnockoutObservable<number>;
  address_type: KnockoutObservable<string>;
  place_id: KnockoutObservable<string>;
  address: KnockoutObservable<address>;

  constructor(item: any) {
    this.address_id = ko.observable(item.address_id);
    this.address_type = ko.observable(item.address_type).extend({ maxLength: 128 });
    this.place_id = ko.observable(item.place_id).extend({ maxLength: 32 });
    this.address = ko.observable();
    if (item.address) {
      this.address(new address(item.address));
    }
  }
}

export class address {
  access_group: KnockoutObservable<string>;
  address_category: KnockoutObservable<string>;
  address_status: KnockoutObservable<string>;
  attention: KnockoutObservable<string>;
  county_id: KnockoutObservable<string>;
  external_ref: KnockoutObservable<string>;
  full_address: KnockoutObservable<string>;

  constructor(item: any) {
    this.access_group = ko.observable(item.access_group).extend({ maxLength: 128 });
    this.address_category = ko.observable(item.address_category).extend({ maxLength: 128 });
    this.address_status = ko.observable(item.address_status).extend({ maxLength: 128 });
    this.attention = ko.observable(item.attention).extend({ maxLength: 64 });
    this.county_id = ko.observable(item.county_id).extend({ maxLength: 32 });
    this.external_ref = ko.observable(item.external_ref).extend({ maxLength: 128 });
    this.full_address = ko.observable(item.full_address).extend({ maxLength: 128 });
  }
}

export class meter_readings {
  meter_name: KnockoutObservable<string>;
  external_source: KnockoutObservable<string>;
  meter_reading_id: KnockoutObservable<number>;
  meter_value: KnockoutObservable<number>;
  product_id: KnockoutObservable<string>;
  reading_dttm: KnockoutObservable<Date>;
  billing_status: KnockoutObservable<string>;

  constructor(item: any) {
    this.meter_name = ko.observable(item.meter_name);
    this.external_source = ko.observable(item.external_source).extend({ maxLength: 32 });
    this.meter_reading_id = ko.observable(item.meter_reading_id);
    this.meter_value = ko.observable(item.meter_value);
    this.product_id = ko.observable(item.product_id).extend({ maxLength: 32 });
    this.reading_dttm = ko.observable(item.reading_dttm);
    this.billing_status = ko.observable(item.billing_status);
  }
}

export class wty_cov_type {
  description: KnockoutObservable<string>;
  warranty_type: KnockoutObservable<string>;
  wty_cov_type: KnockoutObservable<string>;

  constructor(item: any) {
    this.description = ko.observable(item.description).extend({ maxLength: 256 });
    this.warranty_type = ko.observable(item.warranty_type).extend({ maxLength: 128 });
    this.wty_cov_type = ko.observable(item.wty_cov_type).extend({ maxLength: 32 });
  }
}

export class model {
  model_id: KnockoutObservable<string>;
  internal_descriptn: KnockoutObservable<string>;

  constructor(item: any) {
    this.model_id = ko.observable(item.model_id);
    this.internal_descriptn = ko.observable(item.model_id);
  }
}

export class exception_type {
  type: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item: any) {
    this.type = ko.observable(item.type);
    this.description = ko.observable(item.type);
  }
}

export class global_code_table {
  code_name: KnockoutObservable<any>;
  code_value: KnockoutObservable<any>;
  description: KnockoutObservable<any>;
  parent_code_value: KnockoutObservable<any>;
  user_def1: KnockoutObservable<any>;

  constructor(item: any) {
    this.code_name = ko.observable(item.code_name);
    this.code_value = ko.observable(item.code_value);
    this.description = ko.observable(item.description);
    this.user_def1 = ko.observable(item.user_def1);

    if (!item.description && item.message_id) {
      this.description(item.message_id);
    }
    if (item.message_id) {
      let s = labels.descr(item.message_id);

      if (!(s === item.message_id)) {
        this.description(s);
      }
    }
    this.parent_code_value = ko.observable();

    if (item.global_code_hierarchy_value) {
      this.parent_code_value(item.global_code_hierarchy_value.parent_code_value);
    }
  }
}

export class req_status {
  req_status: KnockoutObservable<any>;
  description: KnockoutObservable<any>;

  constructor(item: any) {
    this.req_status = ko.observable(item.req_status);
    this.description = ko.observable(item.description);
  }
}

export class task_status {
  task_status: KnockoutObservable<string>;
  status: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item: any) {
    this.task_status = ko.observable(item.task_status);
    this.status = ko.observable(item.status);
    this.description = ko.observable(item.description);
  }
}

export class contract_status {
  contract_status: KnockoutObservable<string>;
  contract_status_type: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item: any) {
    this.contract_status = ko.observable(item.contract_status);
    this.contract_status_type = ko.observable(item.contract_status_type);
    this.description = ko.observable(item.description);
  }
}

export class contr_type {
  contr_type: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item: any) {
    this.contr_type = ko.observable(item.contr_type);
    this.description = ko.observable(item.description);
  }
}

export class approval_status {
  approval_status: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item: any) {
    this.approval_status = ko.observable(item.code_value);
    this.description = ko.observable(item.message_id);
  }
}

export class part_line_code {
  part_line_code: KnockoutObservable<string>;
  description: KnockoutObservable<string>;

  constructor(item: any) {
    this.part_line_code = ko.observable(item.part_line_code);
    this.description = ko.observable(item.description);
  }
}

export class team extends team_member {
  constructor(item: any) {
    super(item);
  }
}

export class user_role {
  description: KnockoutObservable<string>;
  user_def2: KnockoutObservable<string>;
  user_def4: KnockoutObservable<string>;
  user_role: KnockoutObservable<string>;

  constructor(item: any) {
    this.description = ko.observable(item.description).extend({ maxLength: 256 });
    this.user_def2 = ko.observable(item.user_def2).extend({ maxLength: 256 });
    this.user_def4 = ko.observable(item.user_def4).extend({ maxLength: 256 });
    this.user_role = ko.observable(item.user_role).extend({ maxLength: 32 });
  }
}

export class request {
  isCollapsed: KnockoutObservable<boolean>;
  status: KnockoutObservable<any>;
  originalPriority: KnockoutObservable<any>;
  isCompleted: KnockoutObservable<boolean>;
  canInteract: KnockoutObservable<boolean>;
  phenomenon_class: KnockoutObservable<{}>;
  hasSoftware: KnockoutComputed<string>;
  hasHardware: KnockoutComputed<any>;
  isEscalated: KnockoutComputed<boolean>;
  task: KnockoutObservableArray<task>;
  selectedProduct: KnockoutObservable<productExtended>;
  formattedcreated_dttm: any;
  formatteddead_line: any;
  request_attachment: KnockoutObservableArray<request_attachment>;
  c_request_text_view: KnockoutObservableArray<c_request_text_view>;
  c_portal_journal_view: KnockoutObservableArray<c_portal_journal_view>;
  request_id: KnockoutObservable<any>;
  created_by: KnockoutObservable<any>;
  req_type: KnockoutObservable<any>;
  req_class: KnockoutObservable<any>;
  req_group: KnockoutObservable<any>;
  req_status: KnockoutObservable<any>;
  created_dttm: KnockoutObservable<Date>;
  cust_prob_descr: KnockoutObservable<any>;
  external_reference: KnockoutObservable<any>;
  dead_line: KnockoutObservable<Date>;
  firmware: KnockoutObservable<any>;
  business_impact: KnockoutObservable<any>;
  escalation_status: KnockoutObservable<any>;
  operating_system: KnockoutObservable<any>;
  connection: KnockoutObservable<any>;
  network_interface: KnockoutObservable<any>;
  phenomenon: KnockoutObservable<any>;
  actual_result: KnockoutObservable<any>;
  reproduce: KnockoutObservable<any>;
  expected_result: KnockoutObservable<any>;
  attached_product: KnockoutObservable<any>;
  conclusion: KnockoutObservable<any>;
  action_already_taken: KnockoutObservable<any>;
  main_counter: KnockoutObservable<any>;
  project_size: KnockoutObservable<any>;
  software_version_no: KnockoutObservable<any>;
  business_descr: KnockoutObservable<any>;
  end_user: KnockoutObservable<any>;
  user_def1: KnockoutObservable<any>;
  user_def2: KnockoutObservable<any>;
  user_def3: KnockoutObservable<any>;
  user_def4: KnockoutObservable<any>;
  user_def6: KnockoutObservable<any>;
  user_def8: KnockoutObservable<any>;
  user_def9: KnockoutObservable<any>;
  user_def13: KnockoutObservable<any>;
  user_def16: KnockoutObservable<any>;
  user_def23: KnockoutObservable<any>;
  user_def_dttm1: KnockoutObservable<Date>;
  user_def_dttm2: KnockoutObservable<Date>;
  user_def_num1: KnockoutObservable<number>;
  user_def_num2: KnockoutObservable<number>;

  reqextens_user_def1: KnockoutObservable<string>;
  reqextens_user_def2: KnockoutObservable<string>;
  reqextens_user_def3: KnockoutObservable<string>;
  reqextens_user_def4: KnockoutObservable<string>;
  reqextens_user_def10: KnockoutObservable<string>;

  constructor(item: any) {
    this.isCollapsed = ko.observable(true);
    this.request_id = ko.observable(item.request_id);
    this.created_by = ko.observable(item.created_by);
    this.req_type = ko.observable(item.req_type);
    this.req_class = ko.observable(item.req_class);
    this.req_group = ko.observable(item.req_group);
    this.req_status = ko.observable(item.req_status);
    this.status = ko.observable(item.status);
    this.created_dttm = ko.observable(formatJSONDate(item.created_dttm));
    this.cust_prob_descr = ko.observable(item.cust_prob_descr).extend({ required: true });
    this.external_reference = ko.observable(item.external_reference);
    this.operating_system = ko.observable(item.operating_system);
    this.connection = ko.observable(item.connection);
    this.network_interface = ko.observable(item.network_interface);
    this.phenomenon = ko.observable(item.phenomenon).extend({ required: true });
    this.actual_result = ko.observable(item.actual_result).extend({ required: true });
    this.expected_result = ko.observable(item.expected_result).extend({ required: true });
    this.attached_product = ko.observable(item.attached_product);
    this.conclusion = ko.observable(item.conclusion).extend({ required: true });
    this.action_already_taken = ko.observable(item.action_already_taken);
    this.reproduce = ko.observable(item.reproduce).extend({ required: true });
    this.main_counter = ko.observable(item.main_counter).extend({ digit: true });
    this.firmware = ko.observable(item.firmware);
    this.business_impact = ko.observable(item.business_impact);
    this.escalation_status = ko.observable(item.escalation_status);
    this.software_version_no = ko.observable(item.software_version_no).extend({ required: true });
    this.business_descr = ko.observable(item.business_descr);

    this.originalPriority = ko.observable(item.user_def8);
    this.user_def1 = ko.observable(item.user_def1);
    this.user_def2 = ko.observable(item.user_def2); //.extend({ validation: { name: 'user_def2', entity: this } });
    this.user_def3 = ko.observable(item.user_def3);
    this.user_def4 = ko.observable(item.user_def4);
    this.user_def6 = ko.observable(item.user_def6);
    this.user_def8 = ko.observable(item.user_def8);
    this.user_def9 = ko.observable(item.user_def9);
    this.user_def13 = ko.observable(item.user_def13);
    this.user_def16 = ko.observable(item.user_def16);
    this.user_def23 = ko.observable(item.user_def23);
    this.user_def_dttm1 = ko.observable(item.user_def_dttm1);
    this.user_def_dttm2 = ko.observable(item.user_def_dttm2);
    this.user_def_num1 = ko.observable(item.user_def_num1);
    this.user_def_num2 = ko.observable(item.user_def_num2);

    this.dead_line = ko.observable(formatJSONDate(item.dead_line)).extend({
      required: {
        onlyIf: () => {
          return this.user_def23() == "03" && this.user_def1() == "04";
        },
        params: true,
      },
    });
    this.end_user = ko.observable(item.end_user).extend({
      required: {
        onlyIf: () => {
          return this.user_def23() == "03" && this.user_def1() == "04";
        },
        params: true,
      },
    });
    this.project_size = ko.observable(item.project_size).extend({
      required: {
        onlyIf: () => {
          return this.user_def23() == "03" && this.user_def1() == "04";
        },
        params: true,
      },
    });

    this.reqextens_user_def1 = ko.observable(item.reqextens_user_def1);
    this.reqextens_user_def2 = ko.observable(item.reqextens_user_def2);
    this.reqextens_user_def3 = ko.observable(item.reqextens_user_def3);
    this.reqextens_user_def4 = ko.observable(item.reqextens_user_def4);
    this.reqextens_user_def10 = ko.observable(item.reqextens_user_def10).extend({ maxLength: 15 });

    this.request_attachment = <KnockoutObservableArray<request_attachment>>(
      loadRelation(item, "request_attachment", "array")
    );
    this.c_request_text_view = <KnockoutObservableArray<c_request_text_view>>(
      loadRelation(item, "c_request_text_view", "array")
    );
    this.c_portal_journal_view = <KnockoutObservableArray<c_portal_journal_view>>(
      loadRelation(item, "c_portal_journal_view", "array")
    );

    this.task = <KnockoutObservableArray<task>>loadRelation(item, "task", "array");
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.formatteddead_line = CustomObservables.formattedDateTimeObservable(this.dead_line);
    this.selectedProduct = <KnockoutObservable<productExtended>>loadRelation(item, "product", "single");
    this.isEscalated = ko.pureComputed(() => {
      if (this.escalation_status()) {
        return !(this.escalation_status() == "NONE");
      } else {
        return false;
      }
    });
    this.hasHardware = ko.pureComputed(() => {
      return this.user_def9() || this.user_def2();
    });
    this.hasSoftware = ko.pureComputed(() => {
      return this.reqextens_user_def3();
    });
    this.phenomenon_class = ko.observable();
    this.canInteract = ko.observable(!_.includes(["CA", "CL", "CO"], item.status));
    this.isCompleted = ko.observable(item.status == "CO");

    if (item.task) {
      let tasks = [];
      if (Array.isArray(item.task)) {
        tasks = item.task;
      } else {
        tasks = [item.task];
      }
      _.each(tasks, (t) => {
        if (t.task_attachment) {
          t["request_attachment"] = t.task_attachment;
          let attachments = <KnockoutObservableArray<request_attachment>>loadRelation(t, "request_attachment", "array");
          _.each(attachments(), (a) => {
            if (a.attachment()) {
              a.task_id(t.task_id);
              a.request_id(this.request_id());
              this.request_attachment.push(a);
            }
          });
        }
      });
    }
    if (item.cust_prob_descr) {
      this.cust_prob_descr(
        item.cust_prob_descr.replace(
          "************************************************************************************************************************",
          "************************ ************************************** ********************************** ************************",
        ),
      );
    }
  }
}

export class request_unit {
  request: KnockoutObservable<request>;
  request_unit_id: KnockoutObservable<number>;
  request_id: KnockoutObservable<string>;

  constructor(item) {
    this.request_unit_id = ko.observable(item.request_unit_id);
    this.request_id = ko.observable(item.request_id);
    this.request = <KnockoutObservable<request>>loadRelation(item, "request", "single");
  }
}

export class attachment {
  file: any;
  access_group: KnockoutObservable<string>;
  active: KnockoutObservable<string>;
  attachment_category: KnockoutObservable<string>;
  attachment_class: KnockoutObservable<string>;
  attachment_description: KnockoutObservable<string>;
  attachment_group: KnockoutObservable<string>;
  attachment_id: KnockoutObservable<number>;
  attachment_name: KnockoutObservable<string>;
  attachment_path: KnockoutObservable<string>;
  attachment_status: KnockoutObservable<string>;
  attachment_type: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  download_path: KnockoutObservable<string>;
  external_access: KnockoutObservable<string>;
  file_extension: KnockoutObservable<string>;
  file_size: KnockoutObservable<number>;
  file_type: KnockoutObservable<string>;
  internal_type: KnockoutObservable<string>;
  mobile_path: KnockoutObservable<string>;
  modified_by: KnockoutObservable<string>;
  modified_dttm: KnockoutObservable<Date>;
  on_demand: KnockoutObservable<string>;
  ranking: KnockoutObservable<number>;
  selectable: KnockoutObservable<string>;
  signer: KnockoutObservable<string>;
  solution: KnockoutObservable<string>;
  solution_weight: KnockoutObservable<number>;
  stored: KnockoutObservable<string>;

  constructor(item) {
    this.file = item.file;
    this.access_group = ko.observable(item.access_group);
    this.active = ko.observable(item.active);
    this.attachment_category = ko.observable(item.attachment_category);
    this.attachment_class = ko.observable(item.attachment_class);
    this.attachment_description = ko.observable(item.attachment_description);
    this.attachment_group = ko.observable(item.attachment_group);
    this.attachment_id = ko.observable(item.attachment_id);
    this.attachment_name = ko.observable(item.attachment_name);
    this.attachment_path = ko.observable(item.attachment_path);
    this.attachment_status = ko.observable(item.attachment_status);
    this.attachment_type = ko.observable(item.attachment_type);
    this.created_by = ko.observable(item.created_by);
    this.created_dttm = ko.observable(item.created_dttm);
    this.download_path = ko.observable(item.download_path);
    this.external_access = ko.observable(item.external_access);
    this.file_extension = ko.observable(item.file_extension);
    this.file_size = ko.observable(item.file_size);
    this.file_type = ko.observable(item.file_type);
    this.internal_type = ko.observable(item.internal_type);
    this.mobile_path = ko.observable(item.mobile_path);
    this.modified_by = ko.observable(item.modified_by);
    this.modified_dttm = ko.observable(item.modified_dttm);
    this.on_demand = ko.observable(item.on_demand);
    this.ranking = ko.observable(item.ranking);
    this.selectable = ko.observable(item.selectable);
    this.signer = ko.observable(item.signer);
    this.solution = ko.observable(item.solution);
    this.solution_weight = ko.observable(item.solution_weight);
    this.stored = ko.observable(item.stored);
  }
}

export class request_attachment {
  attachment_id: KnockoutObservable<number>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  modified_by: KnockoutObservable<string>;
  modified_dttm: KnockoutObservable<Date>;
  request_id: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  attachment: KnockoutObservable<attachment>;

  constructor(item) {
    this.attachment_id = ko.observable(item.attachment_id);
    this.created_by = ko.observable(item.created_by);
    this.created_dttm = ko.observable(item.created_dttm);
    this.modified_by = ko.observable(item.modified_by);
    this.modified_dttm = ko.observable(item.modified_dttm);
    this.request_id = ko.observable(item.request_id);
    this.task_id = ko.observable(item.task_id || "");
    this.attachment = loadRelation(item, "attachment", "single");
  }
}

export class screenNote {
  attachment: KnockoutObservable<any>;
  journal_source_type_label_value: KnockoutObservable<any>;
  journal_source_type_label_id: KnockoutObservable<any>;
  journal_source_type: KnockoutObservable<any>;
  request_id: KnockoutObservable<any>;
  task_id: KnockoutObservable<any>;
  line_descr: KnockoutObservable<any>;
  bodyText: KnockoutObservable<any>;
  humanDate: KnockoutComputed<string>;
  formattedcreated_dttm: KnockoutComputed<{}>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;

  constructor(item) {
    this.created_by = ko.observable(item.created_by);

    this.created_dttm = ko.observable(formatJSONDate(item.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.humanDate = ko.pureComputed(() => {
      const format = "YYYY-MM-DD HH:mm:ss";
      const dateFormatted = moment(this.created_dttm()).format(format);
      const humanDateFormatted = moment(this.created_dttm()).fromNow();
      return `${humanDateFormatted} (${dateFormatted})`;
    });
    this.journal_source_type = ko.observable(item.journal_source_type);
    this.journal_source_type_label_id = ko.observable(item.journal_source_type_label_id);
    this.journal_source_type_label_value = ko.observable(item.journal_source_type_label_value);
    this.request_id = ko.observable(item.request_id);
    this.task_id = ko.observable(item.task_id);
    this.bodyText = ko.observable(item.bodyText);
    this.line_descr = ko.observable(item.line_descr);

    this.attachment = loadRelation(item, "attachment", "array");
  }
}

export class c_portal_journal_view {
  modified_dttm: KnockoutObservable<any>;
  modified_by: KnockoutObservable<any>;
  journal_source_type_label_value: KnockoutObservable<any>;
  journal_source_type_label_id: KnockoutObservable<any>;
  journal_source_type: KnockoutObservable<any>;
  journal_source_id: KnockoutObservable<any>;
  journal_secondary_source_id: KnockoutObservable<any>;
  journal_data_5: KnockoutObservable<any>;
  journal_data_4: KnockoutObservable<any>;
  journal_data_3: KnockoutObservable<any>;
  journal_data_2: KnockoutObservable<any>;
  journal_data_1: KnockoutObservable<any>;
  humanDate: KnockoutComputed<string>;
  formattedcreated_dttm: KnockoutComputed<{}>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;

  constructor(item) {
    this.created_by = ko.observable(item.created_by);
    this.created_dttm = ko.observable(formatJSONDate(item.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.humanDate = ko.pureComputed(() => {
      const format = "YYYY-MM-DD HH:mm:ss";
      const dateFormatted = moment(this.created_dttm()).format(format);
      const humanDateFormatted = moment(this.created_dttm()).fromNow();
      return `${humanDateFormatted} (${dateFormatted})`;
    });
    this.journal_data_1 = ko.observable(item.journal_data_1);
    this.journal_data_2 = ko.observable(item.journal_data_2);
    this.journal_data_3 = ko.observable(item.journal_data_3);
    this.journal_data_4 = ko.observable(item.journal_data_4);
    this.journal_data_5 = ko.observable(item.journal_data_5);
    this.journal_secondary_source_id = ko.observable(item.journal_secondary_source_id);
    this.journal_source_id = ko.observable(item.journal_source_id);
    this.journal_source_type = ko.observable(item.journal_source_type);
    this.journal_source_type_label_id = ko.observable(item.journal_source_type_label_id);
    this.journal_source_type_label_value = ko.observable(item.journal_source_type_label_value);
    this.modified_by = ko.observable(item.modified_by);
    this.modified_dttm = ko.observable(item.modified_dttm);
  }
}

export class c_request_text_view {
  humanDate: KnockoutComputed<string>;
  formattedcreated_dttm: KnockoutComputed<{}>;
  request_id: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  request_sequence: KnockoutObservable<number>;
  text_line_code: KnockoutObservable<string>;
  text: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;

  constructor(item) {
    this.request_id = ko.observable(item.request_id);
    this.task_id = ko.observable("0");
    this.request_sequence = ko.observable(item.request_sequence);
    this.text_line_code = ko.observable(item.text_line_code);
    this.text = ko.observable(item.text);
    this.created_by = ko.observable(item.created_by);
    this.created_dttm = ko.observable(formatJSONDate(item.created_dttm));

    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.humanDate = ko.pureComputed(() => {
      const format = "YYYY-MM-DD HH:mm:ss";
      const dateFormatted = moment(this.created_dttm()).format(format);
      const humanDateFormatted = moment(this.created_dttm()).fromNow();
      return `${humanDateFormatted} (${dateFormatted})`;
    });
  }
}

export class c_task_text_view {
  humanDate: KnockoutComputed<string>;
  formattedcreated_dttm: KnockoutComputed<{}>;
  request_id: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  text_sequence: KnockoutObservable<number>;
  text_line_code: KnockoutObservable<string>;
  text: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;

  constructor(item) {
    this.request_id = ko.observable(item.request_id);
    this.task_id = ko.observable(item.task_id);
    this.text_sequence = ko.observable(item.text_sequence);
    this.text_line_code = ko.observable(item.text_line_code);
    this.text = ko.observable(item.text);
    this.created_by = ko.observable(item.created_by);
    this.created_dttm = ko.observable(formatJSONDate(item.created_dttm));

    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.humanDate = ko.pureComputed(() => {
      const format = "YYYY-MM-DD HH:mm:ss";
      const dateFormatted = moment(this.created_dttm()).format(format);
      const humanDateFormatted = moment(this.created_dttm()).fromNow();
      return `${humanDateFormatted} (${dateFormatted})`;
    });
  }
}

export class task {
  c_task_text_view: KnockoutObservableArray<c_task_text_view>;
  request_id: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;

  constructor(item) {
    this.request_id = ko.observable(item.request_id);
    this.task_id = ko.observable(item.task_id);
    this.c_task_text_view = <KnockoutObservableArray<c_task_text_view>>loadRelation(item, "c_task_text_view", "array");
  }
}

export class request_template {
  model_id: KnockoutObservable<string>;
  sequence: KnockoutObservable<number>;
  access: KnockoutObservable<number>;
  request_type: KnockoutObservable<string>;
  task_type: KnockoutObservable<string>;
  group_sequence: KnockoutObservable<number>;
  group_description: KnockoutObservable<string>;
  group_display_id: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  field_name: KnockoutObservable<string>;
  field_obj: KnockoutObservable<any>;
  field_display_id: KnockoutObservable<string>;
  val_type: KnockoutObservable<string>;
  min_length: KnockoutObservable<number>;
  max_length: KnockoutObservable<number>;
  input_type: KnockoutObservable<string>;
  input_cols: KnockoutObservable<number>;
  mandatory: KnockoutObservable<boolean>;
  validation_backend: KnockoutObservable<boolean>;
  target_field: KnockoutObservable<string>;
  parent_field: KnockoutObservable<string>;
  has_error: KnockoutObservable<boolean>;
  readonly: KnockoutObservable<boolean>;

  constructor(item) {
    this.model_id = ko.observable(item.model_id);
    this.sequence = ko.observable(item.sequence);
    this.access = ko.observable(item.access);
    this.request_type = ko.observable(item.request_type);
    this.task_type = ko.observable(item.task_type ? item.task_type : "");

    // make it number if its string
    this.group_sequence =
      typeof item.group_sequence === "string"
        ? ko.observable(+item.group_sequence)
        : ko.observable(item.group_sequence);

    this.group_description = ko.observable(item.group_description);
    this.group_display_id = ko.observable(item.group_display_id);
    this.description = ko.observable(item.description);
    this.field_name = ko.observable(item.field_name);
    this.field_display_id = ko.observable(item.field_display_id);
    this.val_type = ko.observable(item.value_type);
    this.min_length = ko.observable(item.min_length);
    this.max_length = ko.observable(item.max_length);
    this.input_type = ko.observable(item.input_type);
    this.input_cols = ko.observable(item.input_cols);
    this.mandatory = ko.observable(item.mandatory_p == "Y" ? true : false);
    this.validation_backend = ko.observable(item.validation_backend == "Y" ? true : false);
    this.target_field = ko.observable(item.target_field);
    this.parent_field = ko.observable(item.parent_field);
    this.readonly = ko.observable(item?.readonly ?? false);
    this.has_error = ko.observable(item?.has_error ?? false);
  }

  get labelTranslated() {
    return labels.descr(this.field_display_id());
  }
}

export class ComplaintScreenNote {
  complaint_id: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  modified_dttm: KnockoutObservable<string>;
  note_sequence: KnockoutObservable<number>;
  text: KnockoutObservable<string>;
  humanDate: KnockoutComputed<string>;

  constructor(item) {
    this.complaint_id = ko.observable(item.complaint_id);
    this.created_by = ko.observable(item.created_by);
    this.modified_dttm = ko.observable(item.modified_dttm);
    this.note_sequence = ko.observable(item.note_sequence);
    this.text = ko.observable(item.text);

    this.humanDate = ko.pureComputed(() => {
      if (item.modified_dttm) {
        const modified_date = moment.utc(item.modified_dttm).toDate();
        const format = "YYYY-MM-DD HH:mm:ss";
        const dateFormatted = moment(modified_date).format(format);
        const humanDateFormatted = moment(modified_date).fromNow();
        return `${humanDateFormatted} (${dateFormatted})`;
      } else return "";
    });
  }
}

export class PortalHelpDocument {
  sequence: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  message_id: KnockoutObservable<string>;
  role_name: KnockoutObservable<string>;
  file_link: KnockoutObservable<string>;
  file_name: KnockoutObservable<string>;

  constructor(item) {
    this.sequence = ko.observable(item.sequence);
    this.description = ko.observable(item.description);
    this.message_id = ko.observable(item.message_id);
    this.role_name = ko.observable(item.role_name);
    this.file_link = ko.observable(item.file_link);
    this.file_name = ko.observable(item.file_name);
  }
}

export class autocompleteSNObservable {
  serial_id: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;

  constructor(item) {
    this.serial_id = ko.observable(item.serial_id);
    this.model_id = ko.observable(item.model_id);
  }
}

const context = {
  attachment: attachment,
  c_wty_claim_defective_part: c_wty_claim_defective_part,
  request: request,
  request_attachment: request_attachment,
  global_code_table: global_code_table,
  req_status: req_status,
  c_request_text_view: c_request_text_view,
  product: productExtended,
  model: model,
  task: task,
  c_task_text_view: c_task_text_view,
  c_portal_journal_view: c_portal_journal_view,
  screenNote: screenNote,
  person: personExtended,
  person_place: person_place,
  place: place,
  placepersons: personExtended,
  c_portal_func_access_view: c_portal_func_access_view,
  c_portal_subf_access_view: c_portal_subf_access_view,
  request_unit: request_unit,
  place_address: place_address,
  address: address,
  meter_readings: meter_readings,
  wty_cov_type: wty_cov_type,
  person_role: person_role,
  user_role: user_role,
  team: team,
  task_status: task_status,
  part_line_code: part_line_code,
  k_clab: address_book_record,
  contract_status: contract_status,
  contr_type: contr_type,
  approval_status: approval_status,
};

export function loadRelation(source, relationName, relationType) {
  if (source[relationName]) {
    if (!context[relationName]) {
      throw "Relationship entity '" + relationName + "' needs to be defined in entities.ts.";
    }
    if (Array.isArray(source[relationName])) {
      return ko.observableArray(
        ko.utils.arrayMap(source[relationName], function (c) {
          return new context[relationName](c);
        }),
      );
    } else {
      var relation = new context[relationName](source[relationName]);
      if (relationType == "array") {
        return ko.observableArray([relation]);
      } else {
        return ko.observable(relation);
      }
    }
  }
  if (relationType == "array") {
    return ko.observableArray();
  } else {
    return ko.observable(null);
  }
}

export function loadEntities(source, relationName): KnockoutObservableArray<any> {
  if (source[relationName]) {
    if (!context[relationName]) {
      throw "Entity '" + relationName + "' needs to be defined in entities.ts.";
    }
    var relation = null;
    if (Array.isArray(source[relationName])) {
      relation = ko.observableArray(
        ko.utils.arrayMap(source[relationName], function (c) {
          return new context[relationName](c);
        }),
      );
    } else {
      relation = ko.observable(new context[relationName](source[relationName]));
    }
    return relation;
  }
  return ko.observableArray();
}

export const formatJSONDate = (jsonDate) => {
  if (jsonDate == undefined) return null;

  return moment.utc(jsonDate).toDate();
};
